<!-- Popup -->
<div class="d-flex justify-content-center align-items-center" [ngClass]="{'rewards-dialog-div': !minimizeDialog}">
    <!-- Modal -->
    <div class="modal-box reward-dialog rewards-dialog-minimize" [ngClass]="{'rewards-dialog-minimize': minimizeDialog}" id="rewards-dialog">
        <div class="modal1">
            <div class="reward-content">
                <button title="Close (Esc)" type="button" class="close-title" [innerHTML]="svg.closeIcon | safeHtml" (click)="onTogglePopup()" [disabled]="disabledButton"></button>
                <span [innerHTML]="svg.promotionRewardIcon | safeHtml" class="reward-icon"></span>
                <h4>{{ "You have unclaimed rewards" | translate | uppercase }}</h4>
                <!-- <p>{{ "Rewards Available" | translate }}: {{rewardsData?.pending_reward}}</p> -->
                <p class="description-text">{{ "Don't miss out. Redeem now before they expire" | translate }}!</p>

                <div class="button-row">
                    <button type="button" (click)="onRedirect()">{{ 'Redeem Now' | translate| uppercase }}</button>
                </div>

                <label><input type="checkbox" class="m-r-5" (change)="onNotShowAgain($event)"> {{ 'Do not show again' | translate }}</label>
            </div>
        </div>
    </div>
</div>

<!-- Bubble -->
<div class="d-flex justify-content-center align-items-center rewards-bubble opacity-0" [ngClass]="{'hide-ballon': (!showBallon || rewardsData == null), 'rewards-floating-div': minimizeDialog, 'rewards-floating-div-hide': !minimizeDialog}" id="rewards-floating-bubble" [ngStyle]="{'opacity': showBallon? '100%' : '0'}">
    <span>{{rewardsData?.pending_reward}}</span>
    <div class="rewards-floating-content" (click)="onTogglePopup()">
        <div class="floating-rewards-icon" [innerHTML]="svg.promotionRewardIcon | safeHtml"></div>
    </div>
</div>
  